import {
    CASHLIFTPARTNER_SUCCESS,
    CASHLIFTPARTNER_FAILED,
    RESET_CASHLIFTPARTNER,
    LOADING_CASHLIFTPARTNER,
    NETWORK_ERROR_CASHLIFTPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CASHLIFTPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case CASHLIFTPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case CASHLIFTPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_CASHLIFTPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_CASHLIFTPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};